<router-outlet></router-outlet>
<app-loader /> 

